import { useContext } from 'react'
import { useParams } from 'react-router'

// Third party
import { Skeleton } from '@mui/material'
import clsx from 'clsx'

// Component
import InfiniteScrollDataTable from '../../../../../../../../components/common/tables/InfiniteScrollDataTable'
import NoDataAvailable from '../../../NoDataAvailable'

// Types
import { IExhibitorDataTypes as ITypes } from '../../data/exhibitor.data.types'
import IUserStaffListingRootTypes from '../../hooks/useStaffListingRoot.types'

// Firestore

// Helpers

// Hooks

// Models

// Constants
import { MANAGE_CLINIC_EXHIBITOR_CONSTS } from '../../data/exhibitor.data.const'

import '../../../Exhibitors/Exhibitor.css'
// Third party
import { MODAL_CONSTS } from '../../../../../../../../const/modal-const'
import { HandleModalContext } from '../../../../../../../../layout/mainlayout/MainLayout'

// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

// Constants
const MCEC = MANAGE_CLINIC_EXHIBITOR_CONSTS

const ExhibitorScratchedList = ({
  loading,
  staffs,
  onStaffProfileClick,
  ...props
}: ITypes['IExhitiborAllListProps']) => {
  // Hooks and vars
  const handleModal = useContext(HandleModalContext)?.handleModal

  const { eventId } = useParams<{ eventId?: any }>()

  // Functions
  const generateName = (fullName: string) => {
    return fullName
      .split(' ')
      .map((name) => name[0])
      .join('')
      .toUpperCase()
  }

  const columns = [
    {
      name: (
        <span className="text-gray-600 font-normal text-[0.875rem] flex items-center">
          <span className="whitespace-nowrap">{MCEC.COLS.PROFILE}</span>
        </span>
      ),
      cell: (row: IUserStaffListingRootTypes['IStaff']) => (
        <div className="flex items-center">
          <span
            className="w-full h-full rounded-full block shrink-0 cursor-pointer my-2"
            onClick={() => onStaffProfileClick(row)}
          >
            <img
              src={row.staffProfilePicture ?? ''}
              alt="icons"
              className="object-cover w-[45px] h-[45px] rounded-full"
              onError={(e) =>
                ((e.target as any).src =
                  `https://ui-avatars.com/api/?name=${generateName(row.staffName ?? '')}&background=FFFFFF&format=svg&bold=true&color=BCC6D5&rounded=true`)
              }
            />
          </span>
        </div>
      ),
      width: '25%',
    },
    {
      name: (
        <span className="text-gray-600 font-normal text-[0.875rem] flex items-center">
          <span className="whitespace-nowrap">{MCEC.COLS.NAME}</span>
        </span>
      ),
      cell: (row: IUserStaffListingRootTypes['IStaff']) => (
        <div className="flex items-center mr-[5px]">
          <div
            className="text-base text-SeabiscuitDark200ThemeColor font-normal capitalize cursor-pointer"
            onClick={() => onStaffProfileClick(row)}
          >
            {row.staffName}
          </div>
        </div>
      ),
      width: '25%',
    },
    {
      name: (
        <span className="text-gray-600 font-normal text-[0.875rem] flex items-center">
          <span className="whitespace-nowrap">{MCEC.COLS.ROLE}</span>
        </span>
      ),
      cell: (row: IUserStaffListingRootTypes['IStaff']) => (
        <div className="flex items-center">
          <span className="text-base text-SeabiscuitDark200ThemeColor font-normal capitalize">
            {row?.staffRole}
          </span>
        </div>
      ),
      width: '25%',
    },
    // {
    //     name: <span className="text-SeabiscuitDark200ThemeColor font-semibold text-sm flex items-center justify-center w-full">
    //         <span className="whitespace-nowrap">{MCEC.COLS.ELIGIBILITY}</span>
    //     </span>,
    //     cell: (row: IUserStaffListingRootTypes["IStaff"]) => <div className="justify-center w-full flex">
    //         {row?.isElligible ? <img src={IMAGE_URLS.OK} alt="ok" /> : <img src={IMAGE_URLS.NOT_OK} alt="not ok" />}
    //     </div>,
    //     width: "150px"
    // },
    {
      label: MCEC.COLS.PAPERWORK,
      name: (
        <span className="text-gray-600 font-normal text-[0.875rem] flex items-center justify-center w-full">
          <span className="whitespace-nowrap">{MCEC.COLS.PAPERWORK}</span>
        </span>
      ),
      cell: (row: IUserStaffListingRootTypes['IStaff']) => (
        <div className="justify-center w-full flex">
          {row?.areAllPaperworksSigned ? (
            <img src={MCEC.IMAGE_URLS.OK} alt="icon" />
          ) : (
            <img src={MCEC.IMAGE_URLS.NOT_OK} alt="icon" />
          )}
        </div>
      ),
      width: '25%',
    },
  ]

  const openManageEventModal = () => {
    if (handleModal)
      handleModal(true, MODAL_CONSTS.MANAGE_EVENT_MODAL, {
        eventId,
        headingClassName: '!text-SeabiscuitDark200ThemeColor',
      })
  }

  return (
    <>
      {!loading && !staffs.length && !props.searchValue ? (
        <NoDataAvailable
          text={!!props.searchValue ? 'No data found.' : 'No one has registered yet'}
          url=""
          height={240}
          linkText="Edit registrations >"
          imgSrc="assets/placeholders/noUserFound.svg"
          mainClasses="!mx-0"
          onClickOfLink={openManageEventModal}
        />
      ) : (
        <InfiniteScrollDataTable
          hasMore={false}
          fixedHeader={true}
          id="StaffListTable"
          data={staffs}
          columns={columns}
          progressPending={loading}
          disableInfiniteScroll={true}
          className={clsx(
            '!rounded-none exhibitorListTable',
            staffs.length || loading ? '!h-[300px]' : ''
          )}
          noDataComponent={
            <NoDataAvailable
              text={!!props.searchValue ? 'No data found.' : 'No one has registered yet'}
              url=""
              height={175}
              linkText="Edit Event >"
              imgSrc="assets/placeholders/noUserFound.svg"
              onClickOfLink={openManageEventModal}
              mainClasses="!w-[85%] !pl-[15%]"
            />
          }
          progressComponent={
            <div className="flex flex-col flex-wrap items-left justify-start mt-2">
              <div className="flex items-center items-left justify-start ml-[-40px]">
                <Skeleton
                  variant="circular"
                  width={45}
                  height={45}
                  className="mb-4"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
                <Skeleton
                  variant="rounded"
                  width={100}
                  height={20}
                  className="mb-4 ml-6"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
                <Skeleton
                  variant="rounded"
                  width={340}
                  height={20}
                  className="mb-4 ml-20"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
              </div>
              <div className="flex items-center items-left justify-start ml-[-40px]">
                <Skeleton
                  variant="circular"
                  width={45}
                  height={45}
                  className="mb-4"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
                <Skeleton
                  variant="rounded"
                  width={100}
                  height={20}
                  className="mb-4 ml-6"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
                <Skeleton
                  variant="rounded"
                  width={340}
                  height={20}
                  className="mb-4 ml-20"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
              </div>
              <div className="flex items-center items-left justify-start ml-[-40px]">
                <Skeleton
                  variant="circular"
                  width={45}
                  height={45}
                  className="mb-4"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
                <Skeleton
                  variant="rounded"
                  width={100}
                  height={20}
                  className="mb-4 ml-6"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
                <Skeleton
                  variant="rounded"
                  width={340}
                  height={20}
                  className="mb-4 ml-20"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
              </div>
              <div className="flex items-center items-left justify-start ml-[-40px]">
                <Skeleton
                  variant="circular"
                  width={45}
                  height={45}
                  className="mb-4"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
                <Skeleton
                  variant="rounded"
                  width={100}
                  height={20}
                  className="mb-4 ml-6"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
                <Skeleton
                  variant="rounded"
                  width={340}
                  height={20}
                  className="mb-4 ml-20"
                  style={{ backgroundColor: '#F1F3F8' }}
                />
              </div>
            </div>
          }
        />
      )}
    </>
  )
}

export default ExhibitorScratchedList
